import Vue from 'vue'
import fileDownload from 'js-file-download'
import _ from 'lodash'

export const namespaced = true

export const state = {
  documentLoading: false
}

//MUTATIONS are synchronous : mutate / update state => this.$store.commit('ADD_EVENT')
export const mutations = {

  SET_DOCUMENT_LOADING (state, loading) {
    state.documentLoading = loading
  }
}

//ACTIONS are assynchronous : actions fetch datas (AJAX) then send results to mutations (to update local state)  => this.$store.dispatch('createEvent')
export const actions = {
  downloadDocument ({commit, dispatch}, {name, filename}) {
    // console.log(name, filename)
    if (!filename) filename = 'download.pdf'

    if (name) {
      commit('SET_DOCUMENT_LOADING', true)
      return Vue.axios.get(
        `/docs/${ name }`,
        {
          responseType: 'blob',
          timeout: 30000
        }
      ).then(response => {
        commit('SET_DOCUMENT_LOADING', false)
        //getting filename from the server headers
        const h = response.headers['content-disposition']
        if (h) filename = h.split('filename=')[1]
        // forcedownload
        fileDownload(response.data, filename)

        // get a local copy of the ActiveUser
        const activeUser = _.cloneDeep(this.state.user.activeUser)
        if (activeUser && (name === 'convention-assistance' || name === 'cgv' || name === 'mission-tarifs')) {
          if (name === 'convention-assistance') activeUser.legals.convention = false
          if (name === 'cgv') activeUser.legals.cgv = false
          if (name === 'mission-tarifs') activeUser.legals.tarifs = false
          // update user informations after downloading file
          setTimeout(() => {
            dispatch('user/updateUser', { id: activeUser.id, legals: activeUser.legals }, { root: true })
          }, 400)
        }
      }).catch(error => {
        commit('SET_DOCUMENT_LOADING', false)
        dispatch('displayError', {message: 'Erreur de téléchargement du fichier', error}, {root: true})
      })
    }
  },

  openFile ({commit, dispatch}, {slug, filename}) {

    if (!filename) filename = 'download.pdf'

    if (slug) {
      commit('SET_DOCUMENT_LOADING', true)
      return Vue.axios.get(
        `/docs/${ slug }`,
        {
          responseType: 'blob',
          timeout: 30000
        }
      ).then(response => {
        commit('SET_DOCUMENT_LOADING', false)

        //getting filename from the server headers
        const h = response.headers['content-disposition']
        if (h) filename = h.split('filename=')[1]

        // open new window with the file
        const fileURL = window.URL.createObjectURL(response.data)
        window.open(fileURL, filename)

      }).catch(error => {
        commit('SET_DOCUMENT_LOADING', false)
        dispatch('displayError', {message: 'Erreur du lecture du fichier', error}, {root: true})
      })
    }
  }
}
